module.exports = __webpack_public_path__ + "img/jigglemed-750.d0798854.jpg";